import styled from "styled-components";
import { IMAGES } from "../../constants/images";
import CustomButton from "./CustomButton";
import OpenWarningModal from "../WarningModal/OpenWarningModal";

export default function DrawToolFirstMode({ toggleDrawMode, clear, handleAnalysedParams, drawMode }) {
  return (
    <DrawToolContainer>
      <CustomButton
        onClick={toggleDrawMode}
        title={drawMode.area === "simple_select" ? "Enable Draw Mode" : "Disable Draw Mode"}
        isActive={drawMode.area === "draw_line_string"}
        src={IMAGES.LINE}
        alt="Line"
      />
      <OpenWarningModal action={clear}>
        <CustomButton title="Clear" src={IMAGES.BIN} alt="Bin" />
      </OpenWarningModal>
      <CustomButton onClick={() => handleAnalysedParams(true)} title="Calculate" src={IMAGES.CALCULATE} alt="Calculate" />
    </DrawToolContainer>
  );
}

const DrawToolContainer = styled.div`
  display: grid;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  gap: 10px;
  padding: 15px;
  border-radius: 5px;
  font-size: 14px;
`;
